import React from 'react';
import PropTypes from 'prop-types';
import {Form, Button} from 'react-bootstrap';
import {Formik, ErrorMessage, Form as FormikForm} from 'formik';
import * as yup from 'yup';

const Login = props => {
	return (
		<Formik
			initialValues={{Username: '', Password: '', RememberMe: false}}
			onSubmit={props.onLogin}
			enableReinitialize={true}
			validationSchema={yup.object().shape({
				Username: yup.string().required('Please enter your email'),
				Password: yup.string().required('Please enter your password'),
				RememberMe: yup.boolean()
			})}
		>
			{({handleChange, handleBlur, isSubmitting, values, errors, touched}) => (
				<FormikForm>
					<Form.Group className={touched.Username && errors.Username ? 'has-danger' : ''}>
						<Form.Control
							name="Username"
							value={values.Username}
							placeholder="Email"
							onChange={handleChange}
							onBlur={handleBlur}
							className={touched.Username && errors.Username ? 'is-invalid' : ''}
						/>
						<ErrorMessage component="div" className="invalid-feedback" name="Username" />
					</Form.Group>
					<Form.Group className={touched.Password && errors.Password ? 'has-danger' : ''}>
						<Form.Control
							name="Password"
							value={values.Password}
							placeholder="Password"
							type="password"
							onChange={handleChange}
							onBlur={handleBlur}
							className={touched.Password && errors.Password ? 'is-invalid' : ''}
						/>
						<ErrorMessage component="div" className="invalid-feedback" name="Password" />
					</Form.Group>
					<Form.Group>
						<Form.Switch
							name="RememberMe"
							id="RememberMe"
							value={values.RememberMe}
							checked={values.RememberMe}
							onChange={handleChange}
							label="Keep me signed in"
						/>
					</Form.Group>
					{props.authError && <div className="text-danger">{props.authError}</div>}
					<Button disabled={isSubmitting} type="submit">
						{isSubmitting ? 'Logging In...' : 'Log In'}
					</Button>
					<Button variant="link" onClick={props.onForgotPassword}>
						Forgot Password
					</Button>
				</FormikForm>
			)}
		</Formik>
	);
};

Login.propTypes = {
	onLogin: PropTypes.func.isRequired,
	onForgotPassword: PropTypes.func.isRequired
};

export default Login;
